// @flow
import feathers from 'feathers-client'
import socketio from 'feathers-socketio/client'
import io from 'socket.io-client'

import auth from 'feathers-authentication-client'
import local from 'feathers-authentication-local'
import hooks from 'feathers-hooks'

import { API_SERVER_URL, isDev, isTest } from '../config/'

export const socket = io(API_SERVER_URL, {
  autoConnect: !isTest,
  transports: ['websocket']
})

const client = feathers()
  .configure(socketio(socket))
  .configure(hooks())
  .configure(auth({ storage: window.localStorage }))
  .configure(local())

export const services = {
  items: client.service('/items'),
  charities: client.service('/charities'),
  auctions: client.service('/auctions'),
  bids: client.service('/bids'),
  session: client.service('/session'),
  paymentMethod: client.service('paymentMethod'),
  auctionResultsForUser: client.service('auctionResultsForUser'),
  users: client.service('users'),
  userAddress: client.service('userAddress'),
  media: client.service('media'),
  contacts: client.service('/contacts'),
  checkout: client.service('checkout'),
  checkoutItem: client.service('checkoutItem'),
  notifications: client.service('notifications'),
  stripeAccounts: client.service('stripe-account'),
  emailVerification: client.service('email-verification'),
  searchResultsItems: client.service('searchResultsItems'),
  searchResultsAuctions: client.service('searchResultsAuctions')
}

if (isDev) {
  window.services = services
}

export default client



// WEBPACK FOOTER //
// ./src/core/feathers.js